export * from './legend.component';
